import React from 'react';
import Typography from '@material-ui/core/Typography';
import {
    Button, Card, CardBody, CardImg, Input, InputGroup, InputGroupAddon, InputGroupText,
    Modal, ModalBody, ModalFooter, ModalHeader
} from "reactstrap";
import { getImageType, isEmpty, resizeFile } from "../functions/Utility";
import * as Sentry from "@sentry/react";
import { addGoodImage, deleteGoodImage, getGoodImage } from '../functions/Goods';
import { addSystemLog } from '../functions/SystemLog';
import GeneralConfirmModal from './GeneralConfirmModal';
import GoodImageArea from './components/GoodImageArea';
import { getUserById, getUserId } from '../functions/Auth';
import SpinnerOverlay from './components/SpinnerOverlay';


function GoodImageModal(props) {
    const { isOpen, toggle, goodData } = props;

    // good image from dB
    const [goodImageBase64, setGoodImageBase64] = React.useState('');
    const [deleteGoodImageModalIsOpen, setDeleteGoodImageModalIsOpen] = React.useState(false);
    const [defaultDeliveryPhotoImageBase64, setDefaultDeliveryPhotoImageBase64] = React.useState('');


    const [isLoading, setIsLoading] = React.useState(false);





    React.useEffect(() => {
        if (!goodData || isEmpty(goodData) || Object.keys(goodData).length <= 0) return;
        //  Initial API call
        const initData = async () => {
            let goodImageData;
            setIsLoading(true);

            // deliveryPhoto from backend
            goodImageData = await getGoodImage(goodData.goodID);
            setGoodImageBase64(goodImageData.ImageBase64Content);

            setIsLoading(false);
        };
        initData().then();
    }, [goodData]);


    const uploadImage = async (imageToUpload) => {
        setIsLoading(true);
        //resize file will auto encoded to base 64
        let imageToUploadResized = await resizeFile(imageToUpload);

        let imageBase64 = imageToUploadResized;
        let imageBase64HeaderRemoved = imageBase64.split(',')[1];
        // remove the header from the image
        await addGoodImage(goodData.goodID, imageBase64HeaderRemoved);

        await addSystemLog(getUserId(), "4001", goodData.goodID, "WEB-新增貨物圖片");

        setGoodImageBase64(imageBase64HeaderRemoved);
        setIsLoading(false);
    };


    // delete delivery photo
    const deleteGoodImageCmd = async (goodID) => {
        setIsLoading(true);
        await deleteGoodImage(goodID);
        setGoodImageBase64('');
        setIsLoading(false);
    };



    return !isEmpty(goodData) ? (
        <Modal isOpen={isOpen} toggle={toggle}>
            {isLoading ? <SpinnerOverlay /> : ""}


            <ModalHeader toggle={toggle}>
                <div className="pt-2 pb-2">
                    {goodData.goodDescription}
                </div>
            </ModalHeader>
            <ModalBody>
                <Card style={{ border: "none" }}>
                    <CardBody className="mb-2">

                        <GoodImageArea
                            photoID={goodData.goodID}
                            photoBase64={goodImageBase64}
                            onUploadImage={async (fileToUpload) => {
                                await uploadImage(fileToUpload);
                            }}
                            onDeleteImage={() => {
                                setDeleteGoodImageModalIsOpen(true);
                            }}
                        />
                    </CardBody>
                </Card>
            </ModalBody>
            <ModalFooter className="justify-content-between">
                <Button color="primary" onClick={toggle}>OK</Button>
            </ModalFooter>

            <GeneralConfirmModal isOpen={deleteGoodImageModalIsOpen}
                headerText={'確認刪除？'}
                toggle={() => setDeleteGoodImageModalIsOpen(false)}
                onSubmit={async () => {
                    await deleteGoodImageCmd(goodData.goodID);

                    await addSystemLog(getUserId(), "4003", goodData.goodID, "WEB-刪除貨物圖片");

                    setDefaultDeliveryPhotoImageBase64('');
                    setDeleteGoodImageModalIsOpen(false);
                }} />

        </Modal>


    ) : <div />;
}

export default GoodImageModal
